<template>
    <div>
        <router-link to="/suppliers/add"><button class="button is-success">Add New Supplier</button></router-link><br /><br />

        <div class="notification is-info" v-if="loading === true">
            <p>Loading suppliers ...</p>
        </div>

        <div class="notification is-warning" v-if="loading === false && suppliers.length == 0">
            <p>There are no suppliers to display</p>
        </div>
        
        <table class="table is-fullwidth is-striped" v-if="loading === false && suppliers.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Address</th>
                    <th>Telephone</th>
                    <th width="50" v-if="1==2"></th>
                    <th width="50"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in suppliers" :key="row.id">
                    <td>{{ row.name }}</td>
                    <td>{{ row.contact_name }}</td>
                    <td>{{ row.address }}</td>
                    <td>{{ row.telephone }}</td>
                    <td v-if="1==2"><button class="button is-small is-danger">Archive</button></td>
                    <td><button class="button is-small is-link" @click="notWorking()">View</button></td>
                </tr>
                
            </tbody>
        </table>
    </div>

</template>

<script>
    import StoneService from '@/services/StoneService.js';
    //import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'Suppliers',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    suppliers: []
                   
            }
        },
        methods: {
            
            getSuppliers() {
                this.loading=true;
                StoneService.getSuppliers(this.accessToken)
                .then(
                    (suppliers => {
                    
                    this.$set(this, "suppliers", suppliers);
                    this.loading=false;
                    }).bind(this)
                );
            },
            notWorking() {
                alert('Not yet working')
            }
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getSuppliers()
            });
        
        },
    }
</script>